module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "portfolio"
    }
  }, [_c('navigation', {
    attrs: {
      "dark": true
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "item"
  }, [_c('bacon', {
    attrs: {
      "title": _vm.item.title
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "scope"
  }, _vm._l((_vm.item.scope), function(scope) {
    return _c('h2', [_vm._v(_vm._s(scope))])
  })), _vm._v(" "), _c('p', {
    staticClass: "idea",
    domProps: {
      "innerHTML": _vm._s(_vm.item.idea)
    }
  }), _vm._v(" "), _vm._l((_vm.item.media), function(media) {
    return _c('div', {
      key: media.id,
      staticClass: "media-item",
      class: media.type
    }, [_c('h3', [_vm._v(_vm._s(media.title))]), _vm._v(" "), _c('div', {
      staticClass: "images"
    }, [(['logo', 'palette'].includes(media.type)) ? _c('img', {
      attrs: {
        "src": '/dist/' + media.url
      }
    }) : ('fonts' == media.type) ? _vm._l((media.url), function(img) {
      return _c('div', [_c('img', {
        attrs: {
          "src": '/dist/' + img
        }
      })])
    }) : ('grid' == media.type) ? [_vm._l((media.images), function(image, i) {
      return _c('div', {
        staticClass: "grid-item",
        class: image.size,
        style: ({
          'background-image': 'url(/dist/' + image.url + ')'
        }),
        on: {
          "click": function($event) {
            _vm.grid.selected = i;
            _vm.grid.open = true
          }
        }
      })
    }), _vm._v(" "), _c('gallery', {
      attrs: {
        "name": "mood",
        "images": media.images.map(function(el) {
          return el.url
        }),
        "obj": _vm.grid
      }
    })] : ('video' == media.type) ? _c('div', {
      staticClass: "video-wrapper"
    }, [_c('iframe', {
      attrs: {
        "src": media.url,
        "frameborder": "0",
        "allowfullscreen": ""
      }
    })]) : [_vm._l((media.url), function(image, i) {
      return _c('div', {
        staticClass: "thumb"
      }, [_c('img', {
        attrs: {
          "src": '/dist/' + image
        },
        on: {
          "click": function($event) {
            _vm.mood.selected = i;
            _vm.mood.open = true
          }
        }
      })])
    }), _vm._v(" "), _c('gallery', {
      attrs: {
        "name": "grid",
        "images": media.url,
        "obj": _vm.mood
      }
    })]], 2)])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1193c84a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/item.vue
// module id = 152
// module chunks = 0